import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getApiBaseUrl } from '../config';

class InvoiceService {


    static async createOrder(orderData) {
        console.log("creating customer order...")
        try {
            const response = await fetch(`${getApiBaseUrl()}/createCustomerOrder`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(orderData),
            });

            const result = await response.json();
            console.log('Order created:', result);
            return result; // You can return the result in case you need to do something with it
        } catch (error) {
            console.error('Error creating order:', error);
        }
    }

    static generatePDF(orderData) {
        const { formData, cartItems, totalPrice, shippingFee } = orderData;
        
        const doc = new jsPDF();
        doc.setFontSize(20);
        doc.text('Payment Confirmation', 20, 20);

        const currentDate = new Date().toLocaleDateString();
        doc.setFontSize(12);
        doc.text(`Date: ${currentDate}`, 20, 40);
        doc.text(`Customer Name: ${formData.name} ${formData.lastName}`, 20, 50);
        doc.text(`Email: ${formData.email}`, 20, 60);
        doc.text(`Address: ${formData.address}`, 20, 70);
        doc.text(`City: ${formData.city}`, 20, 80);
        doc.text(`Postal Code: ${formData.postalCode}`, 20, 90);

        doc.autoTable({
            head: [['Product', 'Size', 'Color', 'Quantity', 'Price', 'Total']],
            body: cartItems.map(item => [
                item.product, 
                item.size, 
                item.color, 
                item.quantity,
                `$${(item.price || 0).toFixed(2)}`,
                `$${(item.totalPrice || 0).toFixed(2)}`
            ]),
            startY: 100,
            theme: 'striped',
            headStyles: { fillColor: [0, 0, 0] },
            styles: { fontSize: 12, cellPadding: 5 },
            margin: { top: 10, left: 10, right: 10 },
        });
        

        doc.setFontSize(14);
        doc.text(`Shipping Fee: $${(shippingFee || 0).toFixed(2)}`, 20, doc.lastAutoTable.finalY + 10);
        doc.text(`Total Amount: $${totalPrice.toFixed(2)}`, 20, doc.lastAutoTable.finalY + 20);

        const pdfBase64 = doc.output('datauristring');
        InvoiceService.sendInvoice(pdfBase64, formData.email);
    }

    static async sendInvoice(pdfBase64, customerEmail) {
        try {
            const response = await fetch(`${getApiBaseUrl()}/send-invoice`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    customerEmail,
                    adminEmail: 'ruby@rubyredhome.com',
                    pdf: pdfBase64,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log('Invoice sent successfully');
            } else {
                console.error('Error sending invoice:', data.error);
            }
        } catch (error) {
            console.error('Error during API call:', error);
        }
    }
}

export default InvoiceService;
